/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listCopyGroup} from '../api'

export const useMutationListCopyGroup = createReactQueryMutationHook('listCopyGroup', listCopyGroup)
